<template>
    <div class="ppv2-bg-white dark:ppv2-bg-dark ppv2-rounded-3xl ppv2-p-6">
        <Header :title="$t('blog.title')" />
        <BlogTable :token="token" />
    </div>
</template>

<script>
import BlogTable from './BlogTable.vue'
import normalizeSize from '../../../../utils/normalizeSize'
import normalizeFontSize from '../../../../utils/normalizeFontSize'
import Header from '../../../Shared/Header.vue'
export default {
    name: 'Blog',
    props: {
        token: {
            type: String,
            required: true,
        },
    },
    components: {
        BlogTable,
        Header,
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
    },
}
</script>
